import React from "react";
import "./Skills.css";
import { themeContext } from "../../Context";
import { useContext } from "react";
import { AiFillHtml5, AiFillGithub } from "react-icons/ai";
import {
  DiJavascript1,
  DiNpm,
  DiReact,
  DiCss3Full,
  DiMongodb,
  DiNodejs,
  
} from "react-icons/di";
import { FaBootstrap } from "react-icons/fa";

function Skills() {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div className="skill-hero" id="skills">
      <div className="    ">
        <div className="skill-name">
          <span
            data-aos="slide-right"
            style={{ color: darkMode ? "white" : "" }}
          ></span>
          <span>Skills and Tools</span>
          <div>
            <p
              className="skill-details-skill"
              style={{ color: darkMode ? "white" : "" }}
            >
              My technical skill set encompasses the use of{" "}
              <span className="check" style={{ color: "#09a672" }}>
                HTML
              </span>
              ,{" "}
              <span className="check" style={{ color: "#09a672" }}>
                CSS
              </span>
              ,{" "}
              <span className="check" style={{ color: "#09a672" }}>
                JavaScript
              </span>
              ,{" "}
              <span className="check" style={{ color: "#09a672" }}>
                Bootstrap
              </span>
              ,{" "}
              <span className="check" style={{ color: "#09a672" }}>
                Chakra
              </span>
              , and{" "}
              <span className="check" style={{ color: "#09a672" }}>
                React.js
              </span>{" "}
              for front-end development, while I am well-versed in utilizing{" "}
              <span className="check" style={{ color: "#09a672" }}>
                Node.js
              </span>{" "}
              ,
              <span className="check" style={{ color: "#09a672" }}>
                Express.js
              </span>{" "}
              , and{" "}
              <span className="check" style={{ color: "#09a672" }}>
                MongoDb
              </span>{" "}
              for back-end development. Additionally, I employ Git as my version
              control system to maintain and organize my code effectively.
            </p>
          </div>
        </div><h2 style={{textAlign:"center"}}>Skills</h2>
        <div className="hero-icons-skill">
          
          <div>
            <i style={{ color: "var(--orange)" }}>
              <AiFillHtml5 style={{ fontSize: "70px" }} />
              <div style={{ color:"white"}}> HTML5 </div>
            </i>
          
          </div>
          <div>
            <i style={{ color: "var(--orange)" }}>
              <DiJavascript1 style={{ fontSize: "70px" }} />
              <div style={{ color:"white"}}> JavaScript </div>
            </i>
           
          </div>
          
         
          <div>
            <i style={{ color: "var(--orange)" }}>
              <FaBootstrap style={{ fontSize: "70px" }} />
              <div style={{ color:"white"}}> Bootstrap </div>
            </i>
          
          </div>
          <div>
            <i style={{ color: "var(--orange)" }}>
              <DiReact style={{ fontSize: "70px" }} />
              <div style={{ color:"white"}}> React </div>
            </i>
           
          </div>
          <div>
            <i style={{ color: "var(--orange)" }}>
              <DiCss3Full style={{ fontSize: "70px" }} />
              <div style={{ color:"white"}}> CSS3 </div>
            </i>
            
          </div>
          

          <div>
            <i style={{ color: "var(--orange)" }}>
              <DiNodejs style={{ fontSize: "70px" }} />
              <div style={{ color:"white"}}> Node.js </div>
            </i>            
          </div>
          
</div>
<h2 style={{textAlign:"center",marginTop:"50px"}}>Tools</h2>
<div className="hero-icons-skill">

          <div>
            <i style={{ color: "var(--orange)" }}>
              <DiNpm style={{ fontSize: "70px" }} />
              <div style={{ color:"white"}}> NPM</div>
              
            </i>
          
          </div>
          <div>
            <i
              class="fa-brands fa-git-alt"
              style={{ color: "var(--orange)", fontSize: "70px" }}
            >
              <div style={{ color:"white"}}> Github </div>
            </i>
            
          </div>
          <div>
            <i style={{ color: "var(--orange)" }}>
              <DiMongodb style={{ fontSize: "70px" }} />
              <div style={{ color:"white"}}> Mongodb</div>
            </i>
            
          </div>
        </div>
      </div>
    </div>
  );
}

export default Skills;
